import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { useTypedSelector } from 'src/redux/root-reducer'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { FormContainer } from './createTargetStyle'
import { BankSettingsSelectInput } from 'src/components/Global/SelectBox/Select'
import { SelectFrequency } from 'src/components/Global/SelectBox/SelectData'
import { XContestTypes } from 'src/redux/types/xContest'

const CreateTargetWrapper = styled.form`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  margin-top: 73px;
  overflow-y: scroll;
  height: 490px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none;
  }

  .destination {
    margin-top: 40px;
  }
  h4 {
    font-size: 18px;
    line-height: 4px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.5;
  }
  .amount {
    margin-top: 40px;
  }
  .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .target {
    width: 220px;
    background-color: ${({ theme }) => theme.colors.successGreen};
  }
  .targets {
    width: 400px;
    background-color: ${({ theme }) => theme.colors.successGreen};
  }
  .top {
    text-align: center;
    margin-top: 50px;
  }
  .frequency {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .reverse {
    margin-top: -20px;
    color: ${({ theme }) => theme.colors.primary};
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 22px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  .container input:checked ~ .checkmark {
    background-color: #2196f3;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`

const SavingsFrequency = () => {
  let data: any = useTypedSelector((state) => state.userPlanReducer.planForm)
  console.log(data, 'plan')

  let location = useLocation()
  const [error, isError] = useState(false)

  const [planData, setPlanData] = useState({
    saving_frequency: '',
    auto_debit_amount: '',
    saving_type: 'automated',
    main_card: 'new',
    start_date: '',
    device: 'web',
  })
  const { saving_frequency, auto_debit_amount, saving_type } = planData

  //contest automatic saving frequency logic

  const joinForm = useTypedSelector((state) => state.xcontest.joinForm)

  console.log(joinForm)

  const handleContestDispatch = () => {
    dispatch(
      action(XContestTypes.CONTEST_FORM_DATA, {
        ...joinForm,
        saving_frequency: saving_frequency,
        // auto_debit_amount: auto_debit_amount,
      })
    )
  }

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    console.log(planData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }
  const Disabled = () => {
    if (!saving_type || !auto_debit_amount || !saving_frequency) {
      return 'blur'
    }
    return null
  }
  const dispatch = useDispatch()
  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (!saving_frequency || !auto_debit_amount) {
      isError(true)
    }
  }
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal((prev) => !prev)
  }
  return (
    <FormContainer>
      <CreateTargetWrapper onSubmit={handleSubmit}>
        <div className="amount">
          <h4>Auto debit amount</h4>
          <QuicksaveInput
            type="number"
            name="auto_debit_amount"
            placeholder="1000"
            value={auto_debit_amount}
            onChange={handleChange}
          />
        </div>
        <div className="form-group-select">
          <h6>Frequency</h6>
          <BankSettingsSelectInput
            name="saving_frequency"
            value={saving_frequency}
            onChange={handleChange}
          >
            {SelectFrequency.map(({ id, option }) => {
              return <option key={id}>{option}</option>
            })}
          </BankSettingsSelectInput>
        </div>

        <Link
          to={'/plan-created-details'}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className={`target ${Disabled()}`}>
            Create Pin
          </ModalButton>
        </Link>
      </CreateTargetWrapper>
    </FormContainer>
  )
}
export { SavingsFrequency }
// <Link
//   to={`/big/create-target-continue`}
//   state={{ backgroundLocation: location }}
// ></Link>
